<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic

    ib-col(class="flex")
        ib-row
            ib-col(class="insety-16" :class="{'flex-fixed' : $media.l}")
                h2(v-if="isPortal", class="insetx-16") {{ $t('bond_scanner') }}
                h2(v-else, class="insetx-16") {{ $t('bond_search_tool') }}
                span(v-if="!showtabs")
                    ib-button(tone="accent", appearance="clear", @click="callRefresh")
                        +icon-basic-restart
                        |  {{ $t('refresh_results') }}
                    ib-button(tone="accent", @click="callStartOver") {{ $t('start_over') }}
                    ib-button(tone="accent", @click="callShowTabs") {{ $t('edit') }}
                    ib-button(v-if="signedIn && !isPortal & !amSession", tone="accent", @click="callLogOut") {{ $t('log_out') }}

        ib-row
            ib-col
                p(v-if="showtabs && !isPortal", class="fs7 insetx-16") {{ $t('select_filters_click') }}
                CusipSearch(v-if="showCusip", :resetCusip="cusip", @setFilters="setFilters", ref="searchCusip")
                ib-tabs(v-show="showtabs", align="grow", @input="setTab")
                    ib-tab(v-for="tab in tabs", :key="tab.id", :title="tab.name")
                        template(slot="title")
                            div(v-text="tab.name")
                            .fs7.text-regular.before-2(v-num.int="totals[tab.value]")

        ib-row(class="grow")
            BondScanner(:showCurrency="showCurrency",
                :showCountry="showCountry",
                :curTabName="curTabName",
                :curTabVal="curTabVal",
                :cusipId="cusipId"
                :cusip="cusip",
                :instrument="instrument",
                :isMuni="isMuni",
                :isNonUS="isNonUS",
                :isUSCorp="isUSCorp",
                :isTreasury="isTreasury",
                :locations="locations",
                :showRatings="showRatings",
                ref="bondScanner",
                @checkCurrency="setLocation",
                @showTabs="showTabs",
                @hideTabs="hideTabs",
                @startOver="startOver"
                @signedIn="checkSignedIn")
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import PopularScanners from '../components/PopularScanners.vue'
    import CusipSearch from '../components/CusipSearch.vue'
    import BondScanner from '../components/BondScanner.vue'
    import SearchResults from '../components/SearchResults.vue'
    import api from '../api/'
    import mxGb from '../mixin/mixin-global'
    import { countries } from '../js/countries.js'
    import { scanner } from '../js/Scanner'

    export default {
        name: 'BondScannerView',

        mixins: [ mxGb ],

        components: {
            PopularScanners,
            CusipSearch,
            BondScanner,
            SearchResults
        },

        data() {
            return {
                amSession: window.AM_SESSION_ID,
                tabs: [
                    { id: 0, value: "GlobalCorporateBonds", name: this.$t('Global_Corporate_Bonds'), count: "15,766"},
                    { id: 1, value: "USCDs", name: this.$t('US_CDs'), count: "30,988"},
                    //{id:2, name: "USAgencyBonds", value: "US Agency Bonds", count: "3,849"},
                    { id: 2, value: "USTreasuries", name: this.$t('US_Treasuries'), count: "70"},
                    { id: 3, value: "USMuniBonds", name: this.$t('US_Muni_Bonds')},
                    { id: 4, value: "NonUSSvrgnBonds", name: this.$t('Non-US_Sovereign_Bonds'), count: "2,268"},
                ],
                cusipId: '',
                cusip: '',
                curTabVal: 'GlobalCorporateBonds',
                curTabName: this.$t('Global_Corporate_Bonds'),
                isMuni: false,
                isNonUS: false,
                isUSCorp: false,
                isTreasury: false,
                filters: {},
                selTab: 0,
                selCurrency: '',
                showtabs: true,
                mobile:true,
                searching: false,
                showCountry: false,
                showCurrency: false,
                showCusip: true,
                showRatings: false,
                signedIn: false,
                instrument: '',
                locations: '',
                showTabBonds: true,
                totals: {},
                showPopular: false,
                countries: countries(this),
                scanner: scanner
           }
        },

        created() {
            if (this.$route.params && this.$route.params.id >= 0) {
                this.showPopular = true;
            }
            if (!this.showPopular) {
                this.getTotals();
                this.getIserverInfo();
                this.unSubscribeAllMD();
            }

            const queryParams = this.$route.query;
            if (Object.keys(queryParams).length > 0 ) {
                this.$store.dispatch('bondscanner/setFiltersFromUrl', queryParams);
                this.$store.dispatch('bondscanner/setBondFieldsFromUrl', {
                    queryParams: queryParams,
                    states: this.states,
                    countries: this.countries
                });
                if (queryParams.curTabVal) {
                    this.curTabVal = queryParams.curTabVal;
                    const tab = this.tabs.find(tab => tab.value === this.curTabVal);
                    this.switchTab(tab);
                }
            }
        },

        mounted() {
            //keep body right: 0 for modals
            const body = document.body;
            body.style.right = 0 + 'px';
            this.showUrlFilteredResults();
            //Only used in CP
            if (this.showPopular) {
                if (this.$route.params.scanner) {
                    this.setFilters(this.$route.params.scanner.id, '', this.$route.params.scanner);
                } else {
                    this.$router.push({ path: '/wlms/explore' });
                }
            }
        },

        watch: {
            curTabVal: {
                handler(val) {
                    this.isMuni = false;
                    this.isNonUS = false;
                    this.isUSCorp = false;
                    this.isTreasury = false;
                    switch(val) {
                        case 'GlobalCorporateBonds':
                            this.showCountry = true;
                            this.showCurrency = true;
                            this.showRatings = true;
                            this.isUSCorp = true;
                            this.instrument = 'BOND';
                            this.locations = (this.selCurrency !== 'EUR' &&
                            this.selCurrency !== 'GBP')  ? 'BOND.WW' : 'BOND.EU.EURONEXT';
                            break;
                        case 'NonUSSvrgnBonds':
                            this.showCountry = true;
                            this.showCurrency = true;
                            this.showRatings = false;
                            this.isNonUS = true;
                            this.instrument = 'BOND.GOVT.NON-US';
                            this.locations = 'BOND.GOVT.NON-US';
                            break;
                        case 'USCDs':
                            this.showCountry = false;
                            this.showCurrency = false;
                            this.showRatings = false;
                            this.instrument = 'BOND.CD';
                            this.locations = 'BOND.CD.US';
                            break;
                        case 'USMuniBonds':
                            this.showCountry = false;
                            this.showCurrency = true;
                            this.showRatings = true;
                            this.isMuni = true;
                            this.instrument = 'BOND.MUNI';
                            this.locations = 'BOND.MUNI.US';
                            break;
                        case 'USTreasuries':
                            this.showCountry = false;
                            this.showCurrency = false;
                            this.showRatings = false;
                            this.isTreasury = true;
                            this.instrument = 'BOND.GOVT';
                            this.locations = 'BOND.GOVT.US';
                            break;
                    }
                },
                immediate: true
            }
        },
        computed: {
            ...mapState('bondscanner', ['urlFilters', 'bondFields'])
        },

        methods: {
            callLogOut() {
                this.$refs.bondScanner.logOut();
            },

            callShowTabs() {
                this.$refs.bondScanner.showTabs();
            },

            callStartOver() {
                this.$refs.bondScanner.startOver();
            },

            callRefresh() {
                this.$refs.bondScanner.refresh();
            },

            checkSignedIn(sign) {
                this.signedIn = sign;
            },

            getIserverInfo() {
                api.getIserverInfo()
                    .then(res => {
                        console.log('Iserver info: ', res.serverInfo);
                    });
            },

            getParams() {
                // not used
                this.$store.dispatch('bondscanner/getScannerParams')
                .catch(res => this.$alert(res));
            },

            getTotals() {
                const payload = [
                    {
                        instrument: "BOND",
                        locations: "BOND.WW",
                        scanCode: "FAR_MATURITY_DATE",
                        secType: "BOND",
                        maxItems: "1",
                        type: "GlobalCorporateBonds"
                    },
                    {
                        instrument: "BOND.GOVT.NON-US",
                        locations: "BOND.GOVT.NON-US",
                        scanCode: "FAR_MATURITY_DATE",
                        secType: "BOND",
                        maxItems: "1",
                        type: "NonUSSvrgnBonds"
                    },
                    {
                        instrument: "BOND.CD",
                        locations: "BOND.CD.US",
                        scanCode: "FAR_MATURITY_DATE",
                        secType: "BOND",
                        maxItems: "1",
                        type: "USCDs"
                    },
                    {
                        instrument: "BOND.MUNI",
                        locations: "BOND.MUNI.US",
                        scanCode: "FAR_MATURITY_DATE",
                        secType: "BOND",
                        maxItems: "1",
                        type: "USMuniBonds"
                    },
                    {
                        instrument: "BOND.GOVT",
                        locations: "BOND.GOVT.US",
                        scanCode: "FAR_MATURITY_DATE",
                        secType: "BOND",
                        maxItems: "1",
                        type: "USTreasuries"
                    }
                ];
                api.getTotals(payload)
                    .then(res => {
                        this.totals = res;
                    });
            },

            hideTabs() {
                this.showtabs = false;
                this.showCusip = false;
            },

            setCommonSearch() {
                this.showTabBonds = true;
                this.$refs.bondScanner.showTabs();
                this.curTabName = this.tabs[this.selTab].name;
            },

            setLocation(currency) {
               this.selCurrency = currency;
            },

            showTabs(cusip, cusipId) {
                this.showCusip = true;
                this.showtabs = true;
                window.scrollTo(0,0);
                this.cusip = cusip && cusipId != 0 ? cusip : '';
            },

            startOver() {
                this.cusipId = '';
                this.cusip = '';
                this.$router.replace({ query: {} });
                this.$store.dispatch('bondscanner/resetFiltersFromUrl');
                this.$store.dispatch('bondscanner/resetBondFieldsFromUrl');
            },

            setTab(index) {
                const tab = this.tabs[index];
                this.selTab = tab.id;
                this.curTabVal = tab.value;
                this.curTabName = tab.name;
            },

            setFilters(id, cusip, scanner) {
                this.hideTabs();
                if (this.showPopular) {
                    this.cusipId = '';
                    this.cusip = '';
                    if (id === 0 || id === 1) {
                        this.curTabName = this.tabs[0].name
                    } else if (id === 2 || id === 3) {
                        this.curTabName = this.tabs[3].name
                    } else if (id === 4) {
                        this.curTabName = this.tabs[1].name
                    } else if (id === 5) {
                        this.curTabName = this.tabs[2].name
                    }
                } else {
                    this.cusipId = id;
                    this.cusip = cusip;
                    this.curTabName = this.$t('Global_Corporate_Bonds');
                }
                this.$refs.bondScanner.prepareScanner(scanner)
            },
            unSubscribeAllMD() {
                api.unsubscribeAll()
                    .then(res => console.log('Unsubscribe all market data successfully'))
                    .catch(e => console.error('Failed to unsubscribe all market data'));
            },

            showUrlFilteredResults() {
                if (Object.keys(this.urlFilters).length > 0) {
                    if (this.getFilterValue('cusip') && this.getFilterValue('cusipId')) {
                        this.setFilters(this.getFilterValue('cusipId'), this.getFilterValue('cusip'), scanner);
                    } else {
                        this.$refs.bondScanner.onSubmit(this.urlFilters, this.bondFields, true);
                    }
                }
            }
        }
}
</script>

<style lang="less">
@ibRed: #db1222;

a:not([href]):not([tabindex]) {
    color: inherit;
    text-decoration: none;
}

.pointer {
    cursor: pointer;
}

.over-auto {
    overflow: auto;
}

.matdate {
    label {
        display: block;
    }
    //override
    ._field {
        border-radius: 3px;
    }
}
</style>
